import Phone from '@material-ui/icons/PhoneOutlined';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { Caption } from 'components/Typography/Typography';
import Badge from 'components/Badge/Badge';
import { translate } from 'components/Translation';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/addNumbersDialogStyle';
import { makeStyles } from '@material-ui/core';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import { IUserData } from 'utils/api/models/users/corpUserDetails';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface INumberInfoProps {
	prevDepartment: SingleDepartment | undefined;
	newDepartment?: IUserData;
	phoneNumber: string;
}

const NumberInfo = ({ phoneNumber, prevDepartment, newDepartment }: INumberInfoProps) => {
	const classes = useStyles();

	return (
		<div className={classes.numberInfo}>
			<Phone />
			<Caption disableMargin>{phoneNumber}</Caption>
			<ConditionalRender
				show={!!prevDepartment?.name}
				onTrue={() => (
					<Badge hexColor={prevDepartment?.uiColor} filled key={prevDepartment?.deptId}>
						{prevDepartment?.name}
					</Badge>
				)}
				onFalse={() => <Caption disableMargin>{translate('not.assigned.to.department')}</Caption>}
			/>
			<ArrowForward className={classes.arrowForwardIcon} />
			<ConditionalRender
				show={!!newDepartment?.departmentName}
				onTrue={() => (
					<Badge hexColor={newDepartment?.departmentUiColor} filled key={newDepartment?.departmentId}>
						{newDepartment?.departmentName}
					</Badge>
				)}
				onFalse={() => <Caption disableMargin>{translate('not.assigned.to.department')}</Caption>}
			/>
		</div>
	);
};

export default NumberInfo;
